<template>
  <Teleport to="body">
    <div v-if="overlayStack.length" class="browser-page-overlay-root">
      <div class="browser-page-overlay-mask" aria-hidden="true" />
      <div
        v-for="(item, index) in overlayStack"
        :key="item.id"
        class="browser-page-overlay-layer"
        :style="{ zIndex: 100001 + index }"
      >
        <div
          class="browser-page-overlay-panel"
          :class="{
            'browser-page-overlay-panel--viewport90': item.size === 'viewport90',
          }"
          role="dialog"
          :aria-label="item.title"
        >
          <iframe
            class="browser-page-overlay-panel__frame"
            :src="item.url"
            :title="item.title"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useBrowserPageOverlay } from '@/utils/browserPageOverlay';

const { overlayStack } = useBrowserPageOverlay();
</script>

<style lang="scss" scoped>
.browser-page-overlay-root {
  position: fixed;
  inset: 0;
  z-index: 100000;
  pointer-events: none;
}

.browser-page-overlay-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  pointer-events: auto;
}

.browser-page-overlay-layer {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.browser-page-overlay-panel {
  pointer-events: auto;
  width: min(1720px, 96vw);
  height: calc(100vh - 96px);
  max-height: min(96vh, 100%);
  display: flex;
  flex-direction: column;
  background: var(--bg-color);
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
}

.browser-page-overlay-panel--viewport90 {
  width: 90vw;
  height: 90vh;
  max-width: 100%;
  max-height: 100%;
}

.browser-page-overlay-panel__frame {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  border: none;
  background: var(--bg-color);
}
</style>
